import { motion } from "framer-motion";
import { ClipboardList, ShieldCheck, CheckCircle2, Banknote } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Apply",
    desc: "Complete a short online form in about 5 minutes. No SSN or bank credentials required on our site.",
    accent: "#1B63F0",
  },
  {
    n: "02",
    icon: ShieldCheck,
    title: "Review",
    desc: "We match your request to a licensed partner in our network for underwriting review.",
    accent: "#D4AF37",
  },
  {
    n: "03",
    icon: CheckCircle2,
    title: "Approval",
    desc: "Our partner performs their own credit review and presents any offers directly to you.",
    accent: "#17A673",
  },
  {
    n: "04",
    icon: Banknote,
    title: "Funding",
    desc: "Once you accept an offer, funds are typically deposited within 1–3 business days.",
    accent: "#1B63F0",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <div className="ef-overline">How It Works</div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mt-4">
            Four steps. <span className="italic ef-gold-text">No games.</span>
          </h2>
          <p className="mt-4 text-white/60">From application to funding — a straightforward process built for clarity.</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="ef-card p-7 relative overflow-hidden"
                data-testid={`hiw-step-${s.n}`}
              >
                <div
                  className="absolute -top-6 -right-6 font-display text-[80px] font-bold opacity-[0.06]"
                  style={{ color: s.accent }}
                >
                  {s.n}
                </div>
                <div
                  className="h-11 w-11 rounded-xl flex items-center justify-center"
                  style={{ background: `${s.accent}18`, border: `1px solid ${s.accent}40` }}
                >
                  <Icon className="h-5 w-5" style={{ color: s.accent }} />
                </div>
                <div className="mt-5 text-[10px] font-mono uppercase tracking-widest text-white/40">Step {s.n}</div>
                <div className="mt-1 font-display text-2xl font-bold">{s.title}</div>
                <p className="mt-2.5 text-sm text-white/60 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
